// GENERATED by generateConfigRelease.js — do not edit.
// Client id handed to the PayPal JS SDK in CartModal. Switch environments by
// rebuilding: `npm run build-testing` or `npm run build-release`.

export const PAYPAL_CLIENT_ID = "AYz5KLMMnUGWsSNkjo6eLaaC8v7uoFROgt6kW_-l1KKDLm5j4Ds2rmCuOybsD8_E4PyJUsE2uXAATBsf";
export const PAYPAL_ENV: "live" | "sandbox" = "live";
